module.exports = __webpack_public_path__ + "img/partner10.420cd9d4.png";